import { createContext, ReactNode, useEffect, useState } from 'react';
import i18n from '../i18n';

export type LanguageContextProps = {
  selectedLanguage: 'en' | 'de';
  setSelectedLanguage(val: 'en' | 'de'): void;
};

export const LanguageContext = createContext<LanguageContextProps>({
  selectedLanguage: 'en',
  setSelectedLanguage: () => undefined,
});

export type LanguageContextProviderProps = {
  children: ReactNode;
};

export const LanguageContextProvider = ({
  children,
}: LanguageContextProviderProps) => {
  
  const [selectedLanguage, setSelectedLanguage] = useState<'en' | 'de'>('de');

  useEffect(() => {
    const lang = i18n.language as 'en' | 'de';
    if (lang) {
      setSelectedLanguage(lang);
    }
  }, []);

  useEffect(() => {
     i18n.changeLanguage(selectedLanguage)
  }, [selectedLanguage]);

  return (
    <LanguageContext.Provider
      value={{
        selectedLanguage,
        setSelectedLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
